"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[239],{

/***/ 1747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Layout": function() { return /* binding */ Layout; },
  "default": function() { return /* binding */ themes_default; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/styles/global.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	* {\n		margin: 0;\n		padding: 0;\n		outline: none;\n		box-sizing: border-box;\n    letter-spacing: 1px;\n	}\n\n  html {\n    font-size: 10px;\n    font-family: 'Montserrat', sans-serif;\n    color: ",
        ";\n  }\n\n  body {\n    overflow: hidden;\n  }\n\n  svg {\n    stroke-width: 1.5px;\n  }\n\n  #__next {\n    overflow-x: hidden;\n  }\n\n  main {\n    height: 100vh;\n    background-color: ",
        ";\n    overflow: auto;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  input, button, textarea {\n    font-family: 'Montserrat', sans-serif;\n  }\n\n  textarea {\n    min-height: 136px;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n\n  button {\n    border: none;\n    background: none;\n  }\n\n  a {\n    text-decoration: none;\n    color: ",
        ";\n  }\n\n  #nprogress .bar {\n    background: ",
        " !important;\n    height: 3px;\n  }\n\n  #nprogress .peg {\n    box-shadow: 0 0 10px ",
        ",\n                0 0 5px ",
        ";\n  }\n\n  .__jivoMobileButton > *:first-child {\n    width: 48px !important;\n    height: 48px !important;\n    margin-right: ",
        " !important;\n\n    .icons_4f28 {\n      max-width: ",
        " !important;\n      height: ",
        " !important;\n      background-size: contain !important;\n    }\n  }\n\n  @media(min-width: 769px) {\n    [data-title]:not(.tooltip--off) {\n      position: relative;\n\n      ::after {\n        font-size: 1.1rem;\n        content: attr(data-title);\n        position: absolute;\n        top: calc(100% + 12.5px);\n        left: 50%;\n        transform: translateX(-50%) translateY(-5px);\n        background-color: #717171;\n        color: #fff;\n        padding: 5px 7.5px;\n        white-space: nowrap;\n        border-radius: 4px;\n        visibility: hidden;\n        opacity: 0;\n        z-index: 9999999;\n\n        transition: visibility 0.18s, opacity 0.18s, transform 0.18s;\n        will-change: transition;\n\n        pointer-events: none;\n      }\n\n      :hover::after {\n        visibility: visible;\n        opacity: 1;\n        transform: translateX(-50%);\n      }\n\n      ::before {\n        content: '';\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        background-color: transparent;\n        border-left: 7.5px solid transparent;\n        border-top: 7.5px solid transparent;\n        border-bottom: 7.5px solid #717171;\n        border-right: 7.5px solid transparent;\n        z-index: 9999999;\n\n        transform: translateX(-50%) translateY(-5px);\n        visibility: hidden;\n        opacity: 0;\n\n        transition: visibility 0.18s, opacity 0.18s, transform 0.18s;\n        will-change: transition;\n      }\n\n      :hover::before {\n        visibility: visible;\n        opacity: 1;\n        transform: translateX(-50%);\n      }\n    }\n  }\n\n\n  ::-webkit-scrollbar {\n    width: ",
        ";\n    height: ",
        ";\n    background: ",
        ";\n  }\n  ::-webkit-scrollbar-thumb {\n    background: ",
        ";\n  }\n  ::-webkit-scrollbar-track {\n    background-color: ",
        ";\n  }\n\n\n  @keyframes skeleton {\n    0% {\n      background-position: -100%;\n    }\n    100% {\n      background-position: 200%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    * {\n      cursor: default;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject(), (p)=>p.theme.colors.textDark, (p)=>p.theme.colors.background, (p)=>p.theme.colors.placeholder, (p)=>p.theme.colors.textDark, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.large;
}, (p)=>p.theme.font.xLarge, (p)=>p.theme.font.xLarge, (p)=>p.theme.spacing.nano, (p)=>p.theme.spacing.nano, (p)=>p.theme.colors.background, (p)=>p.theme.colors.primary, (p)=>p.theme.colors.border);

;// CONCATENATED MODULE: ./src/themes/default/index.tsx


const Layout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main-element",
                children: children
            })
        ]
    });
};
/* harmony default export */ var themes_default = (Layout);


/***/ })

}]);